/**
 * ImpersonationBannerScreen — le bandeau d'une session impersonnée, en haut de chaque pile
 * (`RootNavigator`), sur le design system.
 *
 * Portage de l'ancien `common/components/banner/ImpersonationBanner.js`, retiré avec lui. « Déconnecter » part vers
 * `POST api/v1/impersonation/exit` ; les réducteurs de son succès retirent les jetons
 * d'impersonation, vident l'utilisateur et la session — la pile repasse sur la connexion et l'admin
 * retrouve ses comptes. Rien d'autre à faire au succès, d'où `useApiMutation` sans `onSuccess`.
 */
import { shallowEqual, useSelector } from "react-redux"

import { ImpersonationBanner } from "../../../../../../design-system"
import { authService } from "../../../../../../data/services/authService"
import { impersonationBannerViewModel } from "../../../../view-models/auth/Impersonate/impersonateViewModel"
import { IS_WEB } from "../../../hooks/openExternalUrl"
import { useApiMutation } from "../../../hooks/useApiMutation"

/** Sur le web, `/impersonate` le temps que l'effet lance l'échange : le nom serait celui d'avant. */
const onImpersonateRoute = (): boolean =>
    IS_WEB && typeof window !== "undefined" && window.location?.pathname === "/impersonate"

export function ImpersonationBannerScreen() {
    const vm = useSelector((state: unknown) => impersonationBannerViewModel(state, onImpersonateRoute()), shallowEqual)
    const { start } = useApiMutation({ service: authService.exitImpersonation, skipWhilePending: true })

    if (!vm.visible) return null

    return <ImpersonationBanner name={vm.name} exiting={vm.exiting} onExit={() => start()} />
}

export default ImpersonationBannerScreen
